import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDepartment, IPersonalSalary, IPosition, IRealEstateClass } from './interfaces';

export const getPersonalSalaryList = (data: IDynamicTableParams) => {
  return instance()
    .post<IPersonalSalary[]>('/calculatorTariff/personalSalary/list', data)
    .then((response) => response.data);
};

export const getPersonalSalaryAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/calculatorTariff/personalSalary/availableColumns')
    .then((response) => response.data);
};

export const getPersonalSalaryAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/calculatorTariff/personalSalary/availableGroupColumns')
    .then((response) => response.data);
};

export const loadPersonalSalary = (personalSalaryId: number) => {
  return instance()
    .get<IPersonalSalary>('/calculatorTariff/personalSalary/load/' + personalSalaryId)
    .then((response) => response.data);
};

export const createPersonalSalary = (personalSalary: IPersonalSalary) => {
  return instance()
    .post<IPersonalSalary>('/calculatorTariff/personalSalary/save', personalSalary)
    .then((response) => response.data);
};

export const updatePersonalSalary = (personalSalary: IPersonalSalary) => {
  return instance()
    .post<IPersonalSalary>(`/calculatorTariff/personalSalary/${personalSalary.personalSalaryId}/update`, personalSalary)
    .then((response) => response.data);
};

export const deletePersonalSalary = (personalSalaryId: number) => {
  return instance()
    .post('/calculatorTariff/personalSalary/archive', { personalSalaryId })
    .then((response) => response.data);
};

export const recoverPersonalSalary = (personalSalaryId: number) => {
  return instance()
    .post('/calculatorTariff/personalSalary/recover', { personalSalaryId })
    .then((response) => response.data);
};

export const getRealEstateClassListAll = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IRealEstateClass[]>('/calculatorTariff/realEstateClass/search', config)
    .then((response) => response.data);
};

export const getPositions = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IPosition[]>(`/dictionary/positions`, {}, config)
    .then((response) => response.data);
};

export const getDepartments = () => {
  return instance()
    .post<IDepartment[]>('/calculatorTariff/department/listAllNotDeleted')
    .then((response) => response.data);
};

export const getMrp = () => {
  return instance()
    .get<{ groupName: string; settings: { key: string; value: string }[] }>(
      '/appSettings/MONTHLY_CALCULATION_INDICATOR/load',
    )
    .then((response) => {
      return Number(response.data.settings?.[0]?.value) || 0;
    });
};
